
import Vue from 'vue';
import { cloneDeep } from 'lodash';
import { Component, Prop } from 'vue-property-decorator';
import NowhowRadioList from '@/components/NowhowRadioList.vue';

import { ISelectListItem } from '@/types/clienttypes';

/** Implementiert eine Radio-Button-Group mit Label und kompletter Validierung für eine Ja/Nein Auswahl
 * @remarks Rendert je eine Spalte für das Label und die Radio-Buttons (sm-3 und sm-9 im Bootstrap-Grid)
 * @remarks Unterstützt ein 'group-focusout'-Event, welches kurz nach dem Verlassen der Gruppe feuert.
 * @devdoc Verwendet intern die NowhowRadioList Komponente
 */
@Component({
    components: { NowhowRadioList }
})
export default class NowhowRadioYesNo extends Vue {
    @Prop({ required: true, type: String }) private id!: string;

    @Prop({ required: false, type: String }) private name!: string;

    @Prop({ required: false, type: String, default: '' }) private label!: string;

    @Prop({ required: false, type: String, default: 'yes' }) private labelYes!: string;

    @Prop({ required: false, type: String, default: 'no' }) private labelNo!: string;

    @Prop({ required: false, type: Boolean, default: false }) private disabled!: boolean;

    @Prop({ required: false, type: Boolean, default: false }) private readonly!: boolean;

    @Prop({ required: false, type: Boolean, default: false }) private inline!: boolean;

    @Prop({ default: '', type: [String, Object] }) validate!: string | object;

    @Prop({ required: false, type: [Boolean], default: false }) value!: boolean;

    @Prop({ required: false, type: String, default: '' })
    private cy!: string;

    radioYesNoItems = [];

    mounted() {
        this.radioYesNoItems = this.cloneOf(this.yesNoItems);
    }

    /** Liefert eine Kopie von SelectList-Items
     * @devdoc Löst das Problem, dass die RadioList nicht nur den Value zurückliefert sondern auch die Items verändert
     */
    cloneOf(ISelectListItem): Array<ISelectListItem> {
        return cloneDeep(ISelectListItem);
    }

    valueAsString(): string {
        if (this.value !== null) {
            return this.value.toString();
        } else {
            return null;
        }
    }

    /** Liefert die zur Auswahl stehenden Optionen. Per Anforderung gibt es keine leere Auswahl. Der Benutzer ist gezwungen, eine Auswahl zu treffen. */
    yesNoItems: Array<ISelectListItem> = [
        {
            /* yes */
            value: 'true',
            text: this.labelYes,
            selected: false,
            disabled: false
        },
        {
            /* no */
            value: 'false',
            text: this.labelNo,
            selected: false,
            disabled: false
        }
    ];

    private onFocusout(value) {
        this.$emit('focusout', value);
    }

    private onGroupFocusout(value) {
        this.$emit('group-focusout', value);
    }

    /** Gibt den geänderten Wert als Boolean aus */
    onChange(newValue: string) {
        if (newValue === 'true') {
            this.$emit('change', true);
        }
        if (newValue === 'false') {
            this.$emit('change', false);
        }
    }

    /** Gibt den geänderten Wert als Boolean aus */
    onInput(newValue: string) {
        if (newValue === 'true') {
            this.$emit('input', true);
        }
        if (newValue === 'false') {
            this.$emit('input', false);
        }
    }
}
